import React from "react";
import { observer } from "mobx-react-lite";

import useThemeService from "../../../../services/theme-service/ThemeService";
import useModal from "../../../../components/dialog/useModal";
import Button, { ButtonProps } from "../../../../components/button/Button";
import WarningBeforeAction from "../../../../components/data-components/WarningBeforeAction";
import { Restore } from "../../../../components/svg/svgImageList";
import { translationService } from "../../../../services/translation/TranslationService";

interface RestoreButtonProps extends ButtonProps {
  confirmationModalTitleKey: string;
  confirmationAction: () => void;
  disabled?: boolean;
}

const RestoreButton = observer((props: RestoreButtonProps) => {
  const { themeClass } = useThemeService();
  const { toggleModal, isVisible } = useModal();

  const handleConfirmationAction = () => {
    props.confirmationAction();
    toggleModal();
  };

  return (
    <>
      <Button
        id="restore"
        disabled={props.disabled}
        icon={{
          svg: Restore,
          textKey: "general.restore",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-restore"]),
        }}
        onClick={toggleModal}
      />

      <WarningBeforeAction
        isVisible={isVisible}
        toggleModal={toggleModal}
        titleKey={props.confirmationModalTitleKey}
        buttonOk={{
          id: "restore-ok",
          textKey: "general.restore",
          action: handleConfirmationAction,
        }}
      >
        <div>
          <div>{translationService.translate("DeletedData.restore-data.confirmation-part1")}</div>
          <div>{translationService.translate("DeletedData.restore-data.confirmation-part2")}</div>
        </div>
      </WarningBeforeAction>
    </>
  );
});

export default RestoreButton;
